import { createDOMElement } from 'src/utils';
import { networkLogStyle } from './networkLogStyle';
import {
  MAIN_NETWORK_LOG_WRAPPER,
  FOOTER_NETWORK_LOG_WRAPPER,
  NETWORK_RECORDING_OFF,
  NETWORK_DOWNLOAD_SNAPSHOT,
  NETWORK_RECORDING_START,
  NETWORK_RESET_MODE,
  EVENTS,
} from 'utils/enum';
import {
  downloadNetworkLogs,
  initializeNetworkCaptureOnfetch,
} from './networkLogs';
import { log } from 'consoleManager';
let networkCssStatus = true;
let elementRef = {};

const renderNetworkLogUi = () => {
  destroy();
  generateInternalCss();
  createLogUi();
};

const createLogUi = () => {
  try {
    if (elementRef[MAIN_NETWORK_LOG_WRAPPER]) {
      return;
    }
    const dom = {
      ele: 'div',
      attributes: {
        class: 'main-network-log-wrapper',
      },
    };
    const element = createDOMElement(dom);
    const levelLog = createButton();
    element.appendChild(levelLog);
    elementRef[MAIN_NETWORK_LOG_WRAPPER] = element;
    if (document.querySelector('body')) {
      document.querySelector('body')?.append(element);
    }
  } catch (error) {
    console.log(error);
  }
};

const createButton = () => {
  if (elementRef[FOOTER_NETWORK_LOG_WRAPPER]) {
    return;
  }
  const dom = {
    ele: 'div',
    attributes: {
      class: 'footer-network-log-wrapper',
    },
  };
  const element = createDOMElement(dom);
  elementRef[FOOTER_NETWORK_LOG_WRAPPER] = element;
  createRecordingStart();
  return element;
};

const createRecordingStart = () => {
  if (elementRef[NETWORK_RECORDING_START]) {
    return;
  }
  const innerHTML = 'Recording Start';
  const ele = createDOMElement({
    ele: 'button',
    attributes: {
      class: 'network-recording-start enabledButton',
      name: 'recording_start',
    },
    innerHTML,
  });
  ele.addEventListener(EVENTS.click, recordingStart);
  elementRef[NETWORK_RECORDING_START] = ele;
  elementRef[FOOTER_NETWORK_LOG_WRAPPER].appendChild(ele);
  if (localStorage.getItem('AUTO_ENABLE_NETWORK_LOG_MODE') == 'true') {
    recordingStart();
  }
  return ele;
};

const recordingStart = () => {
  if (elementRef[NETWORK_RECORDING_START]) {
    const snapShot = createSnapShot();
    elementRef[FOOTER_NETWORK_LOG_WRAPPER].appendChild(snapShot);
    const recordingOff = createRecordingOff();
    elementRef[FOOTER_NETWORK_LOG_WRAPPER].appendChild(recordingOff);
    initializeNetworkCaptureOnfetch();
    elementRef[NETWORK_RECORDING_START].classList.add('inActiveLog');
  }
};

const createSnapShot = () => {
  if (elementRef[NETWORK_DOWNLOAD_SNAPSHOT]) {
    return;
  }
  const innerHTML = 'SnapShot';
  const dom = {
    ele: 'button',
    attributes: {
      class: 'network-snapShot',
      name: 'download_snapShot',
    },
    innerHTML,
  };
  const ele = createDOMElement(dom);
  ele.addEventListener(EVENTS.click, downloadSnapShot);
  elementRef[NETWORK_DOWNLOAD_SNAPSHOT] = ele;
  return ele;
};

const createRecordingOff = () => {
  if (elementRef[NETWORK_RECORDING_OFF]) {
    return;
  }
  const innerHTML = 'Recording : Stop';
  const recordingDom = {
    ele: 'button',
    attributes: {
      class: 'network-recording-off',
      name: 'recording_stop',
    },
    innerHTML,
  };
  const recordingEle = createDOMElement(recordingDom);
  recordingEle.addEventListener(EVENTS.click, stopRecording);
  elementRef[NETWORK_RECORDING_OFF] = recordingEle;
  return recordingEle;
};

const stopRecording = () => {
  hideNetworkLogScreen();
};
const hideNetworkLogScreen = () => {
  try {
    elementRef[NETWORK_RECORDING_OFF].classList.add('inActiveLog');
    elementRef[NETWORK_DOWNLOAD_SNAPSHOT].classList.add('inActiveLog');
    createResetMode();
    downloadSnapShot();
  } catch (error) {
    console.log(error);
  }
};

const createResetMode = () => {
  if (elementRef[NETWORK_RESET_MODE]) {
    return;
  }
  const innerHTML = 'Reset Mode';
  const ele = createDOMElement({
    ele: 'button',
    attributes: {
      class: 'network-reset-mode enabledButton',
      name: 'reset_log_data',
    },
    innerHTML,
  });
  ele.addEventListener(EVENTS.click, resetLogData);
  elementRef[NETWORK_RESET_MODE] = ele;
  elementRef[FOOTER_NETWORK_LOG_WRAPPER].appendChild(ele);
  return ele;
};

const resetLogData = () => {
  renderNetworkLogUi();
};

const downloadSnapShot = () => {
  if (elementRef[NETWORK_DOWNLOAD_SNAPSHOT]) {
    downloadNetworkLogs();
  }
};

const generateInternalCss = () => {
  if (networkCssStatus) {
    networkCssStatus = false;
    const style = document.createElement('style');
    style.innerText = networkLogStyle;
    document.head.appendChild(style);
  }
};

const destroy = () => {
  try {
    const networkLogger = document.querySelector('.main-network-log-wrapper');
    if (networkLogger) {
      networkLogger?.classList?.remove('main-network-log-wrapper');
    }
    elementRef[MAIN_NETWORK_LOG_WRAPPER]?.remove();
    elementRef = {};
  } catch (error) {
    log(error);
  }
};

export { renderNetworkLogUi };
